import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer } from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-[#0D1B2A] border border-[rgba(0,229,255,0.2)] rounded-xl p-3 shadow-xl">
      <p className="text-[#94A3B8] text-xs mb-1">Day {label}</p>
      {payload?.map((p) => (
        <p key={p?.name} className="text-xs font-mono" style={{ color: p?.color }}>
          {p?.name}: ${p?.value?.toLocaleString()}
        </p>
      ))}
    </div>
  );
};

export default function PredictiveChart({ data, budget, projected }) {
  return (
    <div className="bg-[rgba(255,255,255,0.03)] border border-[rgba(0,229,255,0.1)] rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-[#E2E8F0] font-semibold text-sm">Predictive Spending</h3>
        <div className="flex items-center gap-3 text-xs">
          <span className="flex items-center gap-1.5"><span className="w-3 h-0.5 bg-[#00E5FF] inline-block rounded" />Actual</span>
          <span className="flex items-center gap-1.5 text-[#64748B]"><span className="w-3 h-0.5 bg-[#7B2FBE] inline-block rounded border-dashed" />Projected</span>
        </div>
      </div>
      {projected && (
        <div className="mb-3 p-2.5 rounded-lg bg-[rgba(123,47,190,0.1)] border border-[rgba(123,47,190,0.2)]">
          <p className="text-xs text-[#94A3B8]">
            Projected end-of-month: <span className="text-[#7B2FBE] font-mono font-bold">${projected?.toLocaleString()}</span>
            {budget && projected > budget && <span className="text-[#EF4444] ml-2">(${(projected - budget)?.toLocaleString()} over budget)</span>}
          </p>
        </div>
      )}
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
          <XAxis dataKey="day" tick={{ fill: '#64748B', fontSize: 11 }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fill: '#64748B', fontSize: 11 }} axisLine={false} tickLine={false} tickFormatter={(v) => `$${v}`} />
          <Tooltip content={<CustomTooltip />} />
          {budget && <ReferenceLine y={budget} stroke="#EF4444" strokeDasharray="4 4" label={{ value: 'Budget', fill: '#EF4444', fontSize: 10 }} />}
          <Line type="monotone" dataKey="actual" name="Actual" stroke="#00E5FF" strokeWidth={2} dot={false} />
          <Line type="monotone" dataKey="projected" name="Projected" stroke="#7B2FBE" strokeWidth={2} strokeDasharray="5 5" dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
